import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  RadioGroup,
  Switch,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Tooltip,
  Pagination,
  Dialog,
  Divider,
  MessageBox,
  Tag,
  Scrollbar,
  Backtop,
  Tree,
  Avatar,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Cascader,
  Empty,
  Loading,
  Tabs,
  TabPane,
  Alert,
  Radio,
  Rate,
  Steps,
  Step,
  Progress,
  CheckboxGroup,
  Checkbox,
  Upload,
  Timeline,
  TimelineItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(MenuItem)
Vue.use(RadioGroup)
Vue.use(Switch)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Col)
Vue.use(Row)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Backtop)
Vue.use(Tree)
Vue.use(Avatar)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Cascader)
Vue.use(Empty)
Vue.use(Loading)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Alert)
Vue.use(Radio)
Vue.use(Rate)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Progress)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.prototype.$message = Message // 弹框提示组件，与其它不同需要全局挂载
Vue.prototype.$confirm = MessageBox.confirm // messagebox的确认弹框
